import { Injectable, HostListener, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { response } from 'express';

// Menu
export interface Menu {
	id?: number;
	path?: string;
	title?: string;
	type?: string;
	megaMenu?: boolean;
	image?: string;
	active?: boolean;
	badge?: boolean;
	badgeText?: string;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService implements OnInit {

	constructor(private http: HttpClient) { }


	ngOnInit(): void {
	}

	public screenWidth: any;
	public leftMenuToggle: boolean = false;
	public mainMenuToggle: boolean = false;
	public listaCategorias: any;

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	listarCategorias() {
		return this.http.get(environment.API_SECURITY + "/api/Categorias/shop");
	  };

	listarSubcategorias() {
		return this.http.get(environment.API_SECURITY + "/api/Subcategorias/shop");
	  };

	// MENUITEMS: Menu[] = [
	// 	{
	// 		title: 'Productos', type: 'sub', active: false, children: [
	// 			{
	// 				title: 'Bienestar',
	// 				type: 'sub',
	// 				active: false, children: [
	// 					{
	// 						path: '/shop/collection/left/sidebar/bienestar',
	// 						title: 'Bienestar',
	// 						type: 'link'
	// 					},
	// 				] }
	// 		]
	// 	}
	// ];

	LEFTMENUITEMS: Menu[] = [
		{
			title: 'Productos', type: 'sub', megaMenu: true, active: false, children: [
				{
					title: 'Productos', type: 'sub', active: false, children: [
						{
							title: 'Bienestar',
							type: 'sub',
							active: false, children: [
								{
									path: '/shop/collection/left/sidebar/bienestar',
									title: 'Bienestar',
									type: 'link'
								},
							] }
					]
				}
			]
		},
		{
			title: 'Información', type: 'sub', active: false, children: [
			  { path: '/pages/aviso', title: 'Aviso de Privacidad', type: 'link' },
			  { path: '/pages/terminos-y-condiciones', title: 'Términos y Condiciones', type: 'link' },
			  { path: '/pages/contact', title: 'Contacto', type: 'link' },
			  { path: '/pages/condiciones-envio', title: 'Condiciones de Envío', type: 'link' }
			]
		}
	];

	// Array
	// items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
	leftMenuItems = new BehaviorSubject<Menu[]>(this.LEFTMENUITEMS);

}
